export enum QuickFilterType {
  lastHour = 'lastHour',
  lastThreeDays = 'lastThreeDays',
  lastWeek = 'lastWeek',
  lastThreeWeeks = 'lastThreeWeeks'
}